export var PortRS485;
(function (PortRS485) {
    let Type;
    (function (Type) {
        Type[Type["standard"] = 0] = "standard";
        Type[Type["modbus"] = 1] = "modbus";
    })(Type = PortRS485.Type || (PortRS485.Type = {}));
    PortRS485.speeds = [2400, 4800, 9600, 14400, 19200, 28800, 38400, 57600, 115200];
    PortRS485.stopByteCounts = [1, 2];
    PortRS485.parityCheckDict = [
        { value: 0, text: 'Отсутствует' },
        { value: 1, text: 'Четность' },
        { value: 2, text: 'Нечетность' },
    ];
    PortRS485.DEFAULT = {
        setting_register: 0,
        speed: 9600,
        stop_byte_count: 1,
        parity_check: 0,
    };
})(PortRS485 || (PortRS485 = {}));
